export enum PRINTER_JOB_MODE {
  ALL='ALL',
  SUMMARY = 'SUMMARY',
  ONE_BY_ONE = 'ONE_BY_ONE',
  ONE_QTY_EACH = 'ONE_QTY_EACH',
  BY_PRODUCT_GROUP = 'BY_PRODUCT_GROUP',
  SUMMARY_AND_ONE_BY_ONE = 'SUMMARY_AND_ONE_BY_ONE',
  SUMMARY_AND_ONE_QTY_EACH = 'SUMMARY_AND_ONE_QTY_EACH',
  BY_PRODUCT_GROUP_AND_ONE_BY_ONE = 'BY_PRODUCT_GROUP_AND_ONE_BY_ONE',
  ONE_QTY_EACH_ITEM = 'ONE_QTY_EACH_ITEM',
  TURN_OFF = 'TURN_OFF',
}

// โหมดพื้นฐานที่เลือกได้ (เลือกได้หลายอันต่อ 1 printer)
// ลำดับใน list นี้ = ลำดับ A/B/C/D ที่โชว์ใน UI (usePrinterOptions.printJobModeOptions)
// และเป็นลำดับที่ใช้พิมพ์จริงใน ThermalPrinterJob.printWithMode
// ผู้ใช้เลือก C ก่อน A ก็ยังพิมพ์ A -> C เพราะ normalizePrinterJobModes เรียงตาม list นี้ให้เสมอ
export const PRINTER_JOB_MODE_BASE_LIST: PRINTER_JOB_MODE[] = [
  PRINTER_JOB_MODE.SUMMARY,          // A. รวมทุกรายการใน 1 ใบ
  PRINTER_JOB_MODE.BY_PRODUCT_GROUP, // B. แยกใบตามกลุ่มสินค้า
  PRINTER_JOB_MODE.ONE_BY_ONE,       // C. แยกใบตามรายการ
  PRINTER_JOB_MODE.ONE_QTY_EACH,     // D. แยกใบตาม Qty
];

/** เรียงโหมดตามลำดับ A -> D ก่อนพิมพ์ (ไม่สนลำดับที่ผู้ใช้กดเลือก) */
export function sortPrinterJobModesForPrint(modes: any[]): PRINTER_JOB_MODE[] {
  return PRINTER_JOB_MODE_BASE_LIST.filter((mode) => modes.includes(mode));
}

// ค่าเดิมที่เคยเก็บเป็น string เดี่ยว -> แตกเป็นโหมดพื้นฐาน
const LEGACY_PRINTER_JOB_MODE_MAP: Record<string, PRINTER_JOB_MODE[]> = {
  [PRINTER_JOB_MODE.ALL]: [...PRINTER_JOB_MODE_BASE_LIST],
  [PRINTER_JOB_MODE.SUMMARY_AND_ONE_BY_ONE]: [
    PRINTER_JOB_MODE.SUMMARY,
    PRINTER_JOB_MODE.ONE_BY_ONE,
  ],
  [PRINTER_JOB_MODE.BY_PRODUCT_GROUP_AND_ONE_BY_ONE]: [
    PRINTER_JOB_MODE.BY_PRODUCT_GROUP,
    PRINTER_JOB_MODE.ONE_BY_ONE,
  ],
  [PRINTER_JOB_MODE.ONE_QTY_EACH_ITEM]: [PRINTER_JOB_MODE.ONE_QTY_EACH],
  [PRINTER_JOB_MODE.TURN_OFF]: [],
};

/**
 * แปลงค่า setting `printer_{n}_mode` ให้เป็น array ของโหมดพื้นฐานเสมอ
 * รองรับทั้งค่าใหม่ (array) และค่าเดิม (string เดี่ยว/โหมดรวม)
 */
export function normalizePrinterJobModes(value: any): PRINTER_JOB_MODE[] {
  const rawList = Array.isArray(value) ? value : [value];
  const modes: PRINTER_JOB_MODE[] = [];

  rawList.forEach((raw) => {
    if (!raw || typeof raw !== "string") {
      return;
    }

    const mapped = LEGACY_PRINTER_JOB_MODE_MAP[raw]
      || (PRINTER_JOB_MODE_BASE_LIST.includes(raw as PRINTER_JOB_MODE) ? [raw as PRINTER_JOB_MODE] : []);

    mapped.forEach((mode) => {
      if (!modes.includes(mode)) {
        modes.push(mode);
      }
    });
  });

  // เรียงตามลำดับพิมพ์ (A -> D) เพื่อให้ค่าที่เก็บ/แสดง/พิมพ์ คงที่
  return sortPrinterJobModesForPrint(modes);
}

export function isSamePrinterJobModes(a: any, b: any): boolean {
  const modesA = normalizePrinterJobModes(a);
  const modesB = normalizePrinterJobModes(b);

  return modesA.length === modesB.length
    && modesA.every((mode, index) => mode === modesB[index]);
}

export enum PRINTER_VOID_ITEM_VALUES {
  NONE='NONE',
  CASHIER_AND_STATIONS = 'CASHIER_AND_STATIONS',
  CASHIER_ONLY = 'CASHIER_ONLY',
  STATIONS_ONLY = 'STATIONS_ONLY' 
}
